module.exports = __webpack_public_path__ + "assets/img/fr-fe7318e9.png";